import { batchEditAddressee, editAddressee, getAddresseeDetail, getAddresseeList } from './addressee'
import type { ObjectMap } from 'bv-typings'
import { isArray } from 'bv-validator'
import { arr2Str } from 'bv-utils'
import {
  batchCommitAppeal,
  batchCreateAppeal,
  batchDeleteAppeal,
  batchEditAppeal,
  createAppeal,
  editAppeal,
  getAppealDetail,
  getAppealList,
} from '@/services/distributeMail/appeal'
import {
  batchCommitReminder,
  batchCreateReminder,
  batchDeleteReminder,
  batchEditReminder,
  createReminder,
  editReminder,
  getReminderDetail,
  getReminderList,
} from '@/services/distributeMail/reminder'

const createService = {
  addressee: undefined,
  appeal: createAppeal,
  reminder: createReminder,
}

const editService = {
  addressee: editAddressee,
  appeal: editAppeal,
  reminder: editReminder,
}

const batchCreateService = {
  addressee: undefined,
  appeal: batchCreateAppeal,
  reminder: batchCreateReminder,
}

const batchEditService = {
  addressee: batchEditAddressee,
  appeal: batchEditAppeal,
  reminder: batchEditReminder,
}

const listService = {
  addressee: getAddresseeList,
  appeal: getAppealList,
  reminder: getReminderList,
}

const detailService = {
  addressee: getAddresseeDetail,
  appeal: getAppealDetail,
  reminder: getReminderDetail,
}

const transferArray = (params: ObjectMap) => {
  const result = { ...params }
  // eslint-disable-next-line no-restricted-syntax
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      if (isArray(params[key])) {
        result[key] = arr2Str(params[key])
      }
    }
  }
  return result
}

const deleteService = {
  appeal: batchDeleteAppeal,
  reminder: batchDeleteReminder,
}

const sendService = {
  appeal: batchCommitAppeal,
  reminder: batchCommitReminder,
}

export {
  createService,
  editService,
  batchCreateService,
  batchEditService,
  listService,
  detailService,
  transferArray,
  deleteService,
  sendService,
}


